module.exports = __webpack_public_path__ + "img/ghost-shadow.cf68077c.svg";